const counters: { [key: string]: number } = {};

/**
 * Provides a locally unique ID with the given prefix. (aka LUID)
 */
export const uniqueId = (prefix: string) => {
  counters[prefix] = (counters[prefix] || 0) + 1;
  return `${prefix}${counters[prefix]}`;
};
